import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import posthog from "posthog-js";
import styles from './styles.module.css';
import ReasonButton from "ProfileComponents/CancelSubscriptionV2/ReasonButton";
import { passwordResetForDuplicateAccount } from "../../../api/apiCheckout";
const WhatToDo = () => {
    useEffect(() => {
        posthog?.capture("$pageview");
    }, []);
    const editSubscription = () => {
        passwordResetForDuplicateAccount();
        window.location.href = "/checkout/password-reset-done/";
    };
    return (_jsxs("div", { className: styles.page, children: [_jsx("h1", { children: "You have a different account with this email" }), _jsx("h4", { children: "What would you like to do?" }), _jsxs("div", { className: styles.btn_container, children: [_jsx(ReasonButton, { label: "Continue to Purchase/Checkout", onClick: () => { window.location.href = "/checkout/"; } }, "continue"), _jsx(ReasonButton, { label: "Edit My Subscription", onClick: () => editSubscription() }, "edit")] })] }));
};
export default WhatToDo;
